import React, { memo, FC } from 'react'
import { Box, BoxProps } from '@mui/material'

const SunBoxContainer = (props: BoxProps) => {
  return <Box position="relative" overflow="hidden" {...props} />
}

export default memo(SunBoxContainer)
